import { Steps } from "antd";
import { StyledSteps } from "./style";

const { Step } = Steps;

export const RegistrationSteps = ({ currentStep }: { currentStep: number }) => {
  return (
    <StyledSteps>
      <Steps current={currentStep}>
        <Step />
        <Step />
        <Step />
      </Steps>
    </StyledSteps>
  );
};
